<ul class="mb-0">
    @for(occurrence of poll.occurrences; track $index){
        @if($index < 4){
            <user-poll-occurrence [poll]="poll"
                              [occurrence]="occurrence" 
                              [teams]="teams"
                              (deletePoll)="onDelete($event)"></user-poll-occurrence>
        }                         
    }
    @if(poll.occurrences.length > 4){
        @if(!showAll){
            <span class="text-link" (click)="showAll = true" >
                <small>{{poll.occurrences.length - 4}} {{'polls_settings.show_more' | translate}}</small>
            </span>
        }@else{
            @for(occurrence of poll.occurrences; track $index){
                @if($index >= 4){
                    <user-poll-occurrence [poll]="poll"
                              [occurrence]="occurrence" 
                              [teams]="teams"
                              (deletePoll)="onDelete($event)"></user-poll-occurrence>
                }                         
            }
            <div class="text-link text-center" (click)="showAll = false">
                <small><i class="fa-solid fa-chevron-up pe-1"></i>{{'polls_settings.show_less' | translate}}</small>
            </div>
        }
    }                         
</ul>


